import Text21 from './Text21'
export default Text21
